export const POST_PASSWORD = "CHANGE_PASSWORD/POST_PASSWORD";
export const POST_PASSWORD_SUCCESS = "CHANGE_PASSWORD/POST_PASSWORD_SUCCESS";
export const POST_PASSWORD_ERROR = "CHANGE_PASSWORD/POST_PASSWORD_ERROR";

export const CLEAR_MESSAGE = "CHANGE_PASSWORD/CLEAR_MESSAGE";
